// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__p51iD","logoContainer":"Navbar_logoContainer__i93RV","logo":"Navbar_logo__2IOul","logoHands":"Navbar_logoHands__vE-wg","shake":"Navbar_shake__tRiq8"};